import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import {
  DatePicker as MUIDatePicker,
  type DatePickerProps as MUIDatePickerProps,
} from "@mui/x-date-pickers/DatePicker"
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import { fr } from "date-fns/locale/fr"

export const DatePicker = (props: MUIDatePickerProps) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
      <MUIDatePicker
        {...props}
        displayWeekNumber={true}
        sx={{ width: "100%" }}
        slotProps={{
          textField: {
            variant: "outlined",
          },
        }}
      />
    </LocalizationProvider>
  )
}
